var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "url(#paint0_linear_2343_1538)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 38.75C59 47.7344 50.0156 55 39 55C36.0312 55 33.2969 54.5312 30.7969 53.6719C29.9375 54.2969 28.375 55.2344 26.5781 56.0156C24.7031 56.875 22.4375 57.5 20.25 57.5C19.7031 57.5 19.2344 57.2656 19.0781 56.7969C18.8438 56.3281 19 55.7812 19.3125 55.3906C19.3906 55.3906 19.3906 55.3125 19.4688 55.2344C19.5469 55.1562 19.7031 55 19.8594 54.8438C20.1719 54.4531 20.5625 53.8281 21.0312 53.125C21.8125 51.875 22.5156 50.1562 22.6719 48.2031C20.3281 45.5469 19 42.3438 19 38.75C19 29.8438 27.9062 22.5 39 22.5C50.0156 22.5 59 29.8438 59 38.75Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2343_1538",
    x1: 39.5506,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0145C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#042E7D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.5b0f1cbf2068dd7516d2b5900472eda5.svg";
export { ForwardRef as ReactComponent };